import React from 'react';
import Login from '../components/Login';

const LoginPage = () => (
    <>
        <Login/>
    </>
);

export default LoginPage;